import React from "react";
import { Outlet } from "react-router-dom";
import Header from "../ui/Header";
import PinLockScreen from "../auth/PinLockScreen";
import { OperatorProvider, useOperator } from "../../lib/OperatorContext";

/**
 * Shared authenticated app frame.
 * Auth v2: staff sessions are PIN-locked (OperatorContext); the lock screen
 * replaces the whole frame until an operator PIN is verified. Admin (master
 * emails) bypasses the lock.
 */
function ShellBody() {
  // Navigation is authorized by the signed-in account and route roles.
  return (
    <div className="portal-app-frame bg-background">
      <Header />
      <Outlet />
    </div>
  );
}

export default function AppShell() {
  return (
    <OperatorProvider>
      <ShellBody />
    </OperatorProvider>
  );
}
